import React, {Component} from 'react'
import {Link} from 'react-router-dom'
import {Row, Col} from 'react-bootstrap'
import LoginForm from './form'
import {actions} from '../sagas/session'
import '../stylesheets/App.css'
import '../stylesheets/login.sass'
import {KegImage, Kegmeisters} from '../Keg'

class Login extends Component {
  render() {
    const logout = this.props
      && this.props.location
      && this.props.location.state
      && this.props.location.state.logout

    return (
      <div className='kegmeisters'>
        <div className='scroll-it'>
          <Row>
            <Col xs={3} />
            <Col className={'keg-image-wrapper'} xs={6}>
              <KegImage />
            </Col>
            <Col xs={3} />
          </Row>
          <Row>
            <Col xs={3} />
            <Col xs={6}>
              <div
                className={'login-wrapper'}>
                <Kegmeisters
                  kegClassName={'kegmeisters-keg d-inline-block'}
                  mesitersClassName={'kegmeisters-meisters d-inline-block'}
                  wrapperClassName={'kegmeisters-tag'}
                  kegColor={'#FDBF20'}
                  meistersColor={'#303030'}
                  fontSize={58} />
              </div>
            </Col>
            <Col xs={3} />
          </Row>
          <LoginForm logout={logout} />
          <Link to='/sign_up'>
            <div id={'sign-up'} style={{color: '#007bff', marginTop: '30px'}}>
              Not a Kegmeisters user? Sign Up here!
            </div>
          </Link>
        </div>
      </div>
    )
  };
};

export default Login



// WEBPACK FOOTER //
// ./src/Login/index.js